// Cermin dari backend/src/utils/roleHierarchy.js: superadmin > admin > petugas,
// role yang lebih tinggi otomatis punya akses role di bawahnya.
const ROLE_HIERARCHY = {
  superadmin: ['admin', 'petugas'],
  admin: ['petugas'],
};

export function expandRoles(roles) {
  const result = new Set(roles || []);
  let changed = true;
  while (changed) {
    changed = false;
    for (const role of [...result]) {
      for (const implied of ROLE_HIERARCHY[role] || []) {
        if (!result.has(implied)) {
          result.add(implied);
          changed = true;
        }
      }
    }
  }
  return [...result];
}
